<template>
  <div style="background: rgb(0,2,61);color: #a6a6a6;padding: 55px 0 30px 0">
    <div :class="[pc ? 'mw1200' : 'm20']">
      <div style="display: flex;justify-content: space-between;padding-bottom: 20px">
        <div>
          <span :class="{f30: !pc}" style="font-size: 22px;margin-right: 20px">{{ $t('foot.p1') }}</span>
          <div style="display: inline-block;position: relative" @mouseenter="visible = true" @mouseleave="visible = false">
            <img src="@/assets/footer1.png" width="40" height="40" style="margin-right: 20px;cursor: pointer">
            <div v-show="visible" style="position: absolute;bottom: 50px;left: -128px;background: rgba(0,0,0,0.85)">
              <img src="/acnImg/foot/wx.png" />
            </div>
          </div>
          <a href="https://www.linkedin.com/company/acn-worldwide" target="_blank">
            <img src="@/assets/footer2.png" width="40" height="40" />
          </a>
        </div>
        <div v-if="this.pc">
          <span style="font-size: 22px;margin-right: 20px">{{isEn?'Links:':'友情链接：'}}</span>
        <a href="http://www.rimpac-shanghai.cn" target="_blank">
            <img src="@/assets/link2.png" width="100" height="45">
          </a>
         
          <a-divider type="vertical" style="height: 45px;margin: 0 23px;background: #737373" />
          <a href="https://www.theoxfordspires.co.uk" target="_blank">
            <img src="@/assets/link3.png" width="100" height="45">
          </a>
          <a-divider type="vertical" style="height: 45px;margin: 0 23px;background: #737373" />
          <a href="https://vipresidency.com" target="_blank">
            <img src="@/assets/link4.png" width="100" height="45">
          </a>
        </div>
      </div>
      <div v-if="pc" style="font-size: 13px;line-height: 18px;border-bottom: 1px #a0a0a0 solid;padding-bottom: 10px">{{ $t('foot.p2') }}</div>
      <div v-else style="font-size: 18px;line-height: 24px;border-bottom: 1px #a0a0a0 solid;padding-bottom: 20px">{{ $t('foot.p2') }}</div>
      <div v-if="pc" style="font-size: 12px;display:flex;justify-content: space-between;margin: 10px 0">
        <div>
          <span style="margin-right: 25px;cursor: pointer" @click="$router.push('/privacyPolicy')">{{ $t('foot.p3')[0] }}</span>
          <span style="margin-right: 25px;cursor: pointer" @click="$router.push('/termsOfUse')">{{ $t('foot.p3')[1] }}</span>
          <span style="margin-right: 25px;cursor: pointer" @click="$router.push('/disclaimers')">{{ $t('foot.p3')[2] }}</span>
          <span style="cursor: pointer" @click="goCompany">{{ $t('foot.p3')[3] }}</span>
        </div>
        <div>
          <span>沪ICP备20002926号</span>
          <span style="margin: 0 10px">|</span>
          <span v-if="isEn" style="font-size: 13px">Copyright © 2008-2021 ACN Worldwide Ltd., Shanghai</span>
          <span v-else>©2008-2021 环球华置商务服务（上海）有限公司</span>
          <span style="margin: 0 10px">|</span>
          <span style="font-size: 12px">{{isEn?'All rights reserved.':'版权所有'}}</span>
        </div>
      </div>
      <template v-else>
        <div style="font-size: 16px;line-height: 24px;margin-top: 10px">
          <div style="margin-bottom: 5px">
            <span style="margin-right: 25px;cursor: pointer" @click="$router.push('/privacyPolicy')">{{ $t('foot.p3')[0] }}</span>
            <span style="margin-right: 25px;cursor: pointer" @click="$router.push('/termsOfUse')">{{ $t('foot.p3')[1] }}</span>
            <span style="margin-right: 25px;cursor: pointer" @click="$router.push('/disclaimers')">{{ $t('foot.p3')[2] }}</span>
            <span style="margin-right: 25px;cursor: pointer" @click="goCompany">{{ $t('foot.p3')[3] }}</span>
          </div>
          <div style="line-height: 16px">
            <span>沪ICP备20002926号</span>
            <span style="margin: 0 10px">|</span>
            <span v-if="isEn">Copyright © 2008-2021 ACN Worldwide Ltd., Shanghai</span>
            <span v-else>©2008-2021 环球华置商务服务（上海）有限公司</span>
            <span style="margin: 0 10px">|</span>
            <span>{{isEn?'All rights reserved.':'版权所有'}}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      visible: false
    }
  },
  computed: {
    ...mapGetters(['pc', 'isEn'])
  },
  methods: {
    goCompany () {
      this.$router.push({ name: 'Company', params: { name: 'contactUs' } })
    }
  }
}
</script>
